import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormInputField, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { LockedFormProps } from '../../../types';
import { FieldNames } from '../../FieldNames';
import { EditUserFormValues } from '../schema';
import { LockableField } from './LockableField';

export const EmployeeIncentiveCodeLockableField = ({
    fieldsConfig,
    lockedFields,
    setLockedFields,
}: LockedFormProps) => {
    const lockable = !!fieldsConfig?.includes('equalEmployeeIncentiveCodes');
    const { setValue } = useFormContext<EditUserFormValues>();

    const setIncentiveLocked = (locked: boolean) => {
        setLockedFields?.({ ...lockedFields, [FieldNames.EmployeeIncentiveCode]: !locked });
        setValue(FieldNames.EmployeeIncentiveCode, locked ? '' : undefined, { shouldDirty: true });
    };

    const fieldLocked = useMemo(() => !!lockedFields?.[FieldNames.EmployeeIncentiveCode], [lockedFields]);

    return (
        <LockableField
            locked={fieldLocked}
            lockable={lockable}
            tooltipTextKey={TextKey.UserManagementUnlockField}
            onLockToggle={() => setIncentiveLocked(fieldLocked)}
        >
            <FormInputField
                name={FieldNames.EmployeeIncentiveCode}
                label={<LocalizedText textKey={TextKey.EmployeeIncentiveCode} />}
                disabled={fieldLocked}
            />
        </LockableField>
    );
};
